import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import * as Constants from '../../helpers/Constants'

class Button2 extends Component {
  render() {
    const {
      onClick,
      header,
      loading,
      style,
      className = 'confirm_button ' +
        Constants.WHITE_LABEL.colors.button.primary_gradient,
      disabled
    } = this.props

    return (
      <div
        className={className}
        onClick={() => {
          if (!loading && !disabled) onClick()
        }}
        style={{
          marginTop: 25,
          height: 25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          ...style
        }}
      >
        {loading ? (
          <CircularProgress
            style={{ color: 'white' }}
            thickness={6}
            size={20}
          />
        ) : (
          header
        )}
      </div>
    )
  }
}

export { Button2 }



// WEBPACK FOOTER //
// ./src/components/common/Button2.js